module.exports = __webpack_public_path__ + "img/github.2a0e60f8.svg";